import { render, staticRenderFns } from "./SectionLoadProgress.vue?vue&type=template&id=3087066b&"
import script from "./SectionLoadProgress.vue?vue&type=script&lang=js&"
export * from "./SectionLoadProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports